const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''
const FUNCTIONS_BASE = `${API_BASE_URL}/.netlify/functions`

export const getPlaceSuggestions = async (query, { limit, type } = {}) => {
  if (!query || query.trim().length < 2) {
    return []
  }

  const params = new URLSearchParams({ query: query.trim() })
  if (limit) params.set('limit', String(limit))
  if (type) params.set('type', type)

  const response = await fetch(`${FUNCTIONS_BASE}/places?${params.toString()}`)
  if (!response.ok) {
    const message = await response.text().catch(() => '')
    throw new Error(message || `Places lookup failed (${response.status})`)
  }
  const payload = await response.json().catch(() => ({}))
  return payload.data ?? []
}
